import { KuxPpv } from '@kaltura-ott/tvpil';
import { action, observable } from 'mobx';
import { container } from 'tsyringe';

import type { TransactionStore } from '../transaction/transaction-store';

export class Ppv {
  @observable data: KuxPpv;
  @observable mediaFileId: number;
  assetId: number;

  transactionStore: TransactionStore;

  constructor(data: KuxPpv, mediaFileId: number, assetId: number) {
    this.transactionStore = container.resolve<TransactionStore>('transactionStore');
    this.data = data;
    this.mediaFileId = mediaFileId;
    this.assetId = assetId;
  }

  /**
   * method to call for renting (purchasing rent) current PPV plan
   *
   */

  @action
  async rent() {
    return await this.transactionStore.transactionRent({
      ppv: this.data,
      mediaFileId: this.mediaFileId,
      assetId: this.assetId,
    });
  }
}
